import * as actionTypes from "../ActionTypes";

export const curriculumReadAction = (payload) => ({
    type: actionTypes.CURRICULUM_READ_REQUEST,
    payload,
});

export const curriculumHomeReadAction = (payload) => ({
    type: actionTypes.CURRICULUM_HOME_READ_REQUEST,
    payload,
});


export const churchCurriculumSaveAction = (payload) => ({
  type: actionTypes.CHURCH_CURRICULUM_SAVE_REQUEST,
  payload,
});

export const churchCurriculumDeleteAction = (payload) => ({
    type: actionTypes.CHURCH_CURRICULUM_DELETE_REQUEST,
    payload,
  });

  export const churchJournalSaveAction = (payload) => ({
    type: actionTypes.CHURCH_JOURNAL_SAVE_REQUEST,
    payload,
  });
  